import CorporateDataService from "../../../../context/corporates.services";

export const UpdateNameCompany = async ({ id, value, enqueueSnackbar, setIsLoading }) => {
    try {
        if(value.length < 59 && value.length > 0){
            setIsLoading(true)
            await CorporateDataService.updateCorporate('nameCompany', value, id);
            enqueueSnackbar(`Le nom de l'entreprise a été modifié en : ${value}.`, {
                variant: 'success',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}
               
              });
              return true;
        }else{
            enqueueSnackbar(`${value.length > 0 ? "Le nom de l'entreprise ne doit pas dépasser 59 caractères." : "Veuillez saisir un nom valide"}`, {
                variant: 'error',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}
               
              });
              return false;
        }
    }catch(e) {
        enqueueSnackbar(`${e.message}`, {
            variant: 'error',
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            autoHideDuration: 3000,
            style: {fontSize: '1.6rem'}  
        });
        setIsLoading(false);
        return false;
    }
};